import { ArrowLeft, Shield } from "lucide-react";
import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#09090b] text-white">
      {/* Header */}
      <header className="py-6 px-6 border-b border-white/5">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Link to="/" className="text-[#A1A1AA] hover:text-white transition-colors">
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-center gap-3">
            <Shield className="w-6 h-6 text-[#FFD700]" />
            <h1 className="font-['Playfair_Display'] text-2xl font-bold">Terms of Use</h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="prose prose-invert max-w-none space-y-8">

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-bold text-[#FFD700] mb-4">
              1. Intellectual Property
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">
              The JackAndJillScore platform, including all software, source code, design, user interface, 
              graphics, logos, and documentation, is the exclusive intellectual property of its owner. 
              All rights are reserved. No part of this platform may be reproduced, distributed, or 
              transmitted in any form without the prior written permission of the owner.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-bold text-[#FFD700] mb-4">
              2. Prohibited Activities
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed mb-3">
              The following activities are strictly prohibited:
            </p>
            <ul className="space-y-2 text-[#A1A1AA]">
              <li className="flex items-start gap-2">
                <span className="text-[#FF007F] mt-1.5 text-xs">&#9679;</span>
                Copying, cloning, or reproducing any part of the platform or its source code.
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#FF007F] mt-1.5 text-xs">&#9679;</span>
                Reverse engineering, decompiling, or disassembling the software.
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#FF007F] mt-1.5 text-xs">&#9679;</span>
                Modifying, adapting, or creating derivative works based on the platform.
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#FF007F] mt-1.5 text-xs">&#9679;</span>
                Using the platform for any purpose other than managing dance competition events.
              </li>
              <li className="flex items-start gap-2">
                <span className="text-[#FF007F] mt-1.5 text-xs">&#9679;</span>
                Attempting to gain unauthorized access to any part of the system or its data.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-bold text-[#FFD700] mb-4">
              3. Intended Use
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">
              The JackAndJillScore platform is designed exclusively for the management and scoring of 
              dance competition events, including but not limited to Jack &amp; Jill competitions. 
              Any use of the platform outside of this scope is unauthorized and may result in 
              immediate termination of access.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-bold text-[#FFD700] mb-4">
              4. User Responsibilities
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">
              By using this platform, you agree to use it solely for its intended purpose of managing 
              dance competitions. Festival organizers are responsible for the accuracy of the data they 
              enter, including dancer information, judge assignments, and scoring. Judges are responsible 
              for providing fair and honest scores during competitions.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-bold text-[#FFD700] mb-4">
              5. Service Availability
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">
              We strive to maintain the platform available at all times, especially during live 
              competition events. However, we do not guarantee uninterrupted access and shall not 
              be held liable for any temporary service disruptions.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-bold text-[#FFD700] mb-4">
              6. Limitation of Liability
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">
              The platform is provided "as is" without warranties of any kind. The owner shall not be 
              liable for any direct, indirect, incidental, or consequential damages arising from the 
              use or inability to use the platform.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-bold text-[#FFD700] mb-4">
              7. Modifications to Terms
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">
              The owner reserves the right to modify these terms at any time. Continued use of the 
              platform after changes have been made constitutes acceptance of the updated terms.
            </p>
          </section>

          <section>
            <h2 className="font-['Playfair_Display'] text-xl font-bold text-[#FFD700] mb-4">
              8. Contact
            </h2>
            <p className="text-[#A1A1AA] leading-relaxed">
              For any inquiries regarding these terms or the platform, please contact us at{' '}
              <a href="mailto:jackandjillscoring@gmail.com" className="text-[#FFD700] hover:underline">
                jackandjillscoring@gmail.com
              </a>.
            </p>
          </section>

          <div className="pt-8 mt-8 border-t border-white/10 text-center">
            <p className="text-[#52525B] text-sm">
              Last updated: March 2026
            </p>
            <p className="text-[#52525B] text-sm mt-1">
              JackAndJillScore &mdash; All rights reserved.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
